/**
 * Global mutations.
 */

// default export.
export default {
  /**
   * Set user JWT token into local store.
   *
   * @param state
   * @param jwt
   */
  setJWT (state, jwt) {
    // set raw token data.
    state.jwt = jwt
  },

  setTenants (state, tenants) {
    state.tenants = tenants
  },

  setPatientData (state, patient) {
    state.patient = patient
  },

  setProfessionalData (state, professional) {
    state.professional = professional
  },

  setLoading (state, value = true) {
    state.loading = value
  },

  setUserData (state, user) {
    state.user = user
    state.settings = {
      notify: {
        schedule: true,
        cancel: true,
        transfer: false,
        send: {
          email: true,
          sms: false,
          push: {
            web: true,
            app: false
          }
        },
        dependents: false,
        dependent: [],
        weeklySchedule: false,
        weeklySummary: false,
        supportStatistics: false,
        integration: {
          offline: false,
          ownApi: false,
          medibookApi: false
        }
      },
      ...user.settings
    }
  },

  setSettingsData (state, settings) {
    state.settings = settings
  },

  setSettingsNotifyToggle (state, key) {
    state.settings.notify[key] = !state.settings.notify[key]
  },

  // Integração de dados Restfull
  setSettingsIntegrationOffline (state, key) {
    state.settings.notify.integration[key] = !state.settings.notify.integration[key]
  },

  setSettingsNotifySendToggle (state, key) {
    state.settings.notify.send[key] = !state.settings.notify.send[key]
  },

  setSettingsNotifyPushAppToggle (state) {
    state.settings.notify.send.push.app = !state.settings.notify.send.push.app
  },
  // ativando paramentro se for usar push web
  setSettingsNotifyPushWebToggle (state) {
    state.settings.notify.send.push.web = !state.settings.notify.send.push.web
  },
  // adcionando dependentes para notificaão
  setSettingsDependetsPsush (state, dependent) {
    state.settings.notify.dependent = dependent
  },

  // ativando parametro para notifcaçoes de dependentes
  setSettingsNotifyDependentToggle (state) {
    state.settings.notify.dependents = !state.settings.notify.dependents
  },

  updateAvatar (state, avatar) {
    state.user.avatar = avatar
  },
  clearUserData (state) {
    state.jwt = {
      token: null,
      data: null
    }
    state.user = {
      id: null,
      name: null,
      email: null
    }
    state.settings = {
      notify: {
        schedule: true,
        cancel: true,
        transfer: false,
        send: {
          email: true,
          sms: false,
          push: {
            web: true,
            app: false
          }
        },
        dependents: false,
        dependent: [],
        weeklySchedule: false,
        weeklySummary: false,
        supportStatistics: false,
        integration: {
          offline: false,
          ownApi: false,
          medibookApi: false
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js